import React from 'react';
import Input from '../Input';
import './_textarea.scss';

const TextArea = ({ type, ...restProps }) => (
  <Input type="textarea" className="gbnl-text-area" {...restProps} />
);

export default TextArea;
